export default {"src":"/_next/static/media/CLX.7341df2c.svg","height":18,"width":18};